/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon16Light = forwardRef('ArrowCDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.146 5.647a.5.5 0 0 1 .708 0l3.792 3.792a.5.5 0 0 0 .708 0l3.792-3.792a.5.5 0 0 1 .708.707L9.06 10.147a1.5 1.5 0 0 1-2.122 0L3.146 6.354a.5.5 0 0 1 0-.707Z" })));
});
